import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import connect from "react-redux/es/connect/connect";
import Typography from "@material-ui/core/Typography";
import * as config from "../config";

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  formControl: {
    marginRight: theme.spacing(1),
    minWidth: theme.spacing(1) * 10,
    width: '100%'
  },
  relative: {
    position: 'relative'
  },
  textControl : {
    paddingTop: 0,
    paddingBottom: 5,
  },
  switchControl : {
    width: 58,
    height: 38,
    display: 'inline-flex',
    padding: 12,
    zIndex: 0,
    overflow: 'hidden',
    position: 'relative',
    boxSizing: 'border-box',
    flexShrink: 0,
    verticalAlign: 'middle',
    paddingBottom: 5,
  },
  tableTextField: {
    width: '100%',
    '& fieldset': {
      borderRadius: '0'
    },
    '& input': {
      padding: '20px'
    }
  },
  row: {
    marginBottom: theme.spacing(1),
  }
}));




const Help = ({
                  isOpen,
                  closeDialog,
}) => {

  const classes = useStyles();
  const [open, setOpen] = React.useState(isOpen);


  useEffect( () => {
    setOpen(isOpen);
  }, [ isOpen ]);



  const handleClose = () => {
    closeDialog();
  };


  return (
    <div>
      <Dialog fullWidth maxWidth={'md'} open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">AJUDA</DialogTitle>
        <DialogContent>
          <Grid item xs={12} container spacing={3}>

            <Grid item xs={12} md={12}  lg={12} xl={12} container>
              <Grid item xs={12} md={12} lg={12} xl={12}  className={classes.row} container>
                <Grid item xs={12} md={12}  lg={12} xl={12} container>
                        <Typography>Versao: {config.VERSAO}</Typography>
                </Grid>
              </Grid>




          </Grid>
          </Grid>

        </DialogContent>
        <DialogActions>

          <Button onClick={handleClose} color="default">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.id !== null,
  }
}

export default connect(mapStateToProps, {

})(Help)
